import { FC, ReactNode } from "react"
import classNames from "classnames"
import { Icon, IconColor, IconProps } from "@/components/shared/Icon"
import "./index.scss"

interface AlertSettingProps {
   disabled?: boolean
   iconColor: IconColor
   iconName: IconProps["name"]
   title: string
   children: ReactNode
}

const AlertSetting: FC<AlertSettingProps> = ({
   disabled = false,
   iconColor,
   iconName,
   title,
   children,
}) => {
   return (
      <div
         className={classNames("alert-setting", {
            "alert-setting--disabled": disabled,
         })}
      >
         <div className="alert-setting__header">
            <Icon
               name={iconName}
               color={iconColor}
            />
            <span>{title}</span>
         </div>
         <div className="alert-setting__content-wrapper">{children}</div>
      </div>
   )
}

export default AlertSetting
